import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="max-w-[1280px] mx-auto px-4 md:px-6">
      <ol className="flex items-center gap-1.5 text-xs text-foreground-500 py-4 flex-wrap">
        <li>
          <Link to="/" className="hover:text-primary-600 transition-colors duration-200 cursor-pointer">
            <i className="ri-home-4-line"></i>
            <span className="sr-only">首页</span>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            {item.path && index < items.length - 1 ? (
              <Link to={item.path} className="hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className={index === items.length - 1 ? 'text-foreground-800 font-medium' : ''}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}